import * as Page from '@avcan/prismic/clients/page'
import { Page as Layout } from 'layouts/pages'
import { Static } from 'prismic/layouts'
import { ICE_CLIMB_SLUGS } from '@avcan/constants/products/ice-climbs'

export const getStaticPaths = async () => {
    const paths = ICE_CLIMB_SLUGS.map(slug => ({
        params: {
            slug,
        },
    }))

    return {
        paths,
        fallback: 'blocking',
    }
}

export async function getStaticProps({ locale, params }) {
    return {
        props: {
            document: await Page.get(params.slug, locale),
        },
    }
}

export default function ClimbPage({ document }) {
    return (
        <Layout>
            <Static document={document} />
        </Layout>
    )
}
